import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=6699e922&scoped=true&"
import script from "./SkeletonBox.vue?vue&type=script&lang=js&"
export * from "./SkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&id=6699e922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699e922",
  null
  
)

export default component.exports